import { Text } from '@cinch-labs/design-system'
import styles from './flexbox-two-columns.module.css'
import classNames from 'classnames'
import { useViewport } from '@cinch-labs/shared-util'

export function FlexboxTwoColumns({
  classNamings,
  rows,
}: {
  classNamings?: {
    container?: string
    row?: string
    column?: string
  }
  rows: {
    columns: (string | JSX.Element)[]
    classNames?: string[]
    reverseColumnOrderForMobile: boolean
  }[]
}) {
  const { vw } = useViewport({
    updateOnResize: true,
    updateOnOrientationChange: true,
  })
  const isMobile = vw <= 375

  return (
    <div className={classNames(styles.container, classNamings?.container)}>
      {rows.map((row, i) => (
        <div
          key={'flexbox-row-' + i}
          className={classNames(styles.row, classNamings?.row)}
          style={{
            ...(isMobile && row.reverseColumnOrderForMobile
              ? { flexDirection: 'column-reverse' }
              : {}),
          }}
        >
          {row.columns.map((column, i) => (
            <div
              key={'flexbox-column-' + i}
              className={classNames(styles.column, classNamings?.column)}
            >
              {typeof column === 'string' ? <Text>{column}</Text> : column}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
